import React, { useState, useRef } from 'react';
import { message, Modal, Select, Form } from 'antd';
import { copy } from '@/common/utils';
import App from '../../pages/activity-manage/detail/components/actRoom/components/activityVenue/components/common-card/components/APP';
import Pc from '../../pages/activity-manage/detail/components/actRoom/components/activityVenue/components/common-card/components/PC';
import Mini from '../../pages/activity-manage/detail/components/actRoom/components/activityVenue/components/common-card/components/MINI';
import ModalOutside from '@/components/modal';

function VenueDetailModal({ avenueLinkVisible, setAvenueLinkVisible, cardItem }) {
  const [form] = Form.useForm();
  const timeout = useRef(null);
  const [channel, setChannel] = useState('1');
  const { Option } = Select;

  function handleChange(value) {
    if (value) setChannel(value);
  }

  function toCopy(e, link) {
    e.preventDefault();
    const result = copy(link);
    if (result) {
      message.success('复制成功!');
      reset();
    } else {
      message.success('复制失败!');
      reset();
    }
  }

  function reset() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {}, 1000);
  }

  function RenderChannel(item) {
    switch (channel) {
      case '1':
        return <App item={item} toCopy={toCopy} flag="APP" />;
      case '2':
        return <App item={item} toCopy={toCopy} flag="WQ" />;
      case '3':
        return <Pc item={item} toCopy={toCopy} />;
      case '4':
        return <Mini item={item} toCopy={toCopy} />;
      default:
        return <App item={item} toCopy={toCopy} flag="APP" />;
    }
  }

  const channels = [
    {
      value: 'APP链接',
      id: '1',
    },
    {
      value: 'WQ链接',
      id: '2',
    },
    {
      value: 'PC链接',
      id: '3',
    },
    {
      value: '小程序链接',
      id: '4',
    },
  ];

  return (
    <ModalOutside>
      <Modal
        title="会场链接"
        visible={avenueLinkVisible}
        onCancel={() => {
          setAvenueLinkVisible(false);
        }}
        okText="确认"
        cancelText="取消"
        footer={null}
        width={529}
        className="avenue-link-pop"
      >
        <div className="avenue-link-title">{cardItem.name}</div>
        <div className="avenue-link-form-wrap">
          <Form form={form} labelAlign="right">
            <Form.Item label="活动链接">
              <Select defaultValue="1" style={{ width: 240 }} onChange={handleChange}>
                {channels.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {RenderChannel(cardItem)}
          </Form>
        </div>
      </Modal>
    </ModalOutside>
  );
}

export default VenueDetailModal;
